import Jsona from "jsona";
import qs from "qs";
import axios from "axios";

const jsona = new Jsona();
const url = process.env.VUE_APP_API_BASE_URL;
const includes = [
  "items",
  "items.storable",
  "items.unitOfMeasureUnit",
  "sourceEstablishment",
  "destinationEstablishment",
  "submittedBy",
  "acceptedBy",
];
const resource = "establishment-transfers";

export default {
  list({ filter = {}, include = [], sort = "-created_at", page = { number: 1, size: 25 } } = {}) {
    const params = {
      include: include.length ? include : includes.join(","),
      sort,
      page,
      filter,
    };

    const options = {
      params,
      paramsSerializer: function (params) {
        return qs.stringify(params, { encode: false });
      },
    };

    return axios.get(`${url}/${resource}`, options).then((response) => ({
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    }));
  },

  get({ id, include = [] }) {
    const params = {
      include: include.length ? include : includes.join(","),
    };
    const options = {
      params,
      paramsSerializer: function (params) {
        return qs.stringify(params, { encode: false });
      },
    };
    return axios
      .get(`${url}/${resource}/${id}`, options)
      .then((response) => jsona.deserialize(response.data));
  },

  add({ data, include = [] }) {
    const payload = jsona.serialize({
      stuff: data,
      includeNames: null,
    });

    const params = {
      include: include.length ? include : includes.join(","),
    };

    return axios
      .post(`${url}/${resource}?${qs.stringify(params, { encode: false })}`, payload, {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      })
      .then((response) => jsona.deserialize(response.data));
  },

  update({ data, include = [] }) {
    const payload = jsona.serialize({
      stuff: data,
      includeNames: [],
    });

    const params = {
      include: include.length ? include : includes.join(","),
    };

    return axios
      .patch(`${url}/${resource}/${data.id}?${qs.stringify(params, { encode: false })}`, payload, {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      })
      .then((response) => jsona.deserialize(response.data));
  },

  destroy({ id }) {
    return axios.delete(`${url}/${resource}/${id}`);
  },

  validate({ id, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .get(`${url}/${resource}/${id}/validate?${qs.stringify(params, { encode: false })}`)
      .then((response) => jsona.deserialize(response.data));
  },

  accept({ id, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .get(`${url}/${resource}/${id}/accept?${qs.stringify(params, { encode: false })}`)
      .then((response) => jsona.deserialize(response.data));
  },

  /**
   * Move the accounting date of an accepted transfer: the weekly report
   * counts it on accepted_at.
   */
  changeAcceptedDate({ id, accepted_at }) {
    return axios
      .post(`${url}/${resource}/${id}/change-accepted-date`, { accepted_at })
      .then((response) => jsona.deserialize(response.data));
  },

  reject({ id, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .get(`${url}/${resource}/${id}/reject?${qs.stringify(params, { encode: false })}`)
      .then((response) => jsona.deserialize(response.data));
  },

  cancel({ id, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .get(`${url}/${resource}/${id}/cancel?${qs.stringify(params, { encode: false })}`)
      .then((response) => jsona.deserialize(response.data));
  },

  revertToDraft({ id, include = [] }) {
    const params = { include: include.length ? include : includes.join(",") };
    return axios
      .get(`${url}/${resource}/${id}/revert-to-draft?${qs.stringify(params, { encode: false })}`)
      .then((response) => jsona.deserialize(response.data));
  },

  print({ id }) {
    const options = {
      headers: {},
      responseType: "blob",
    };
    return axios.get(`${url}/${resource}/${id}/print`, options);
  },
};
